import React from 'react'
import { Modal, Box, IconButton } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import '../styles/PdfPreviewModal.css';

const ViewPdfModal = ({
  isModalOpen,
  handleClose,
  pdfImageSrc,
}) => {

  return (
    <Modal
      open={isModalOpen}
      onClose={handleClose}
    >
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: '90%',
          maxWidth: 744,
          maxHeight: '85vh',
          display: 'flex',
          flexDirection: 'column',
          bgcolor: 'background.paper',
          boxShadow: 24,
          p: 4,
          borderRadius: 2,
          '@media (max-width: 600px)': {
            width: '95%',
            p: 2,
          },
        }}
      >
        <IconButton
          onClick={handleClose}
          className="close-button"
          sx={{
            position: 'absolute',
            top: '10px',
            right: '10px',
            zIndex: 10,
            border: '1px solid #ccc',
            background: 'transparent',
            '&:hover': {
              border: '1px solid green',
              color: 'green',
              background: 'transparent',
            },
            borderRadius: '20%',
          }}
        >
          <CloseIcon sx={{ fontSize: { xs: 14, sm: 18 } }} />
        </IconButton>
        <div
          style={{
            flex: 1,
            overflowY: 'auto',
            marginTop: '30px',
            border: '1px solid #ccc',
            borderRadius: '4px',
            boxSizing: 'border-box',
          }}
        >
          <div
            style={{
              padding: '10px',
              boxSizing: 'border-box',
              width: '100%',
              maxWidth: '744px',
              display: 'flex',
              justifyContent: 'center'
            }}
          >
            {pdfImageSrc ? (
              <img
                src={pdfImageSrc}
                style={{
                  width: '100%',
                  height: 'auto',
                  display: 'block'
                }}
                alt="PDF preview"
              />
            ) : (
              <p>Loading PDF preview</p>
            )}
          </div>
        </div>
      </Box>
    </Modal>
  )
}


export default ViewPdfModal;